import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import CustomableShipment from "../components/CustomableShipment";
import Footer from "../components/Footer";
import { useState } from "react";
import Calculator from "../components/Calculator";

const CustomableShipmentPage = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };

  return (
    <>
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData title="Geo Express | Shipment" />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services"],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment", true],
            ]}
            onCalculatorClick={handleShowCalculator}
          />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <CustomableShipment />
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default CustomableShipmentPage;
